import './Super.scss';
import Component from './Super.js';
export default Component;
